import { render, staticRenderFns } from "./RequirementStatusBadge.vue?vue&type=template&id=1bdba1b6&scoped=true"
import script from "./RequirementStatusBadge.vue?vue&type=script&lang=js"
export * from "./RequirementStatusBadge.vue?vue&type=script&lang=js"
import style0 from "./RequirementStatusBadge.vue?vue&type=style&index=0&id=1bdba1b6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bdba1b6",
  null
  
)

export default component.exports